module.exports = __webpack_public_path__ + "static/media/loop.71a63d94.png";